/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SVGIcon, theme, FlexContainer } from "@nordcloud/gnui";

type Props = {
  message: React.ReactNode;
  renderOnTop?: boolean;
  size?: keyof typeof theme.iconSize;
  opacity?: number;
};

export function NoData({
  message,
  renderOnTop = false,
  size = "xxl",
  opacity = 1,
}: Props) {
  return (
    <FlexContainer
      direction="column"
      rowGap={theme.spacing.spacing04}
      justifyContent="center"
      p={`${theme.spacing.spacing02} 0`}
      css={{
        width: "100%",
        height: "100%",
        position: renderOnTop ? "absolute" : "static",
        opacity,
      }}
    >
      <SVGIcon name="emptyData" size={size} />
      {message}
    </FlexContainer>
  );
}
